import { modules } from '@/config/lazyModules';
import { loader } from './lib/lazyModule';

loader(modules);
